(function () {
  const WORKSHOP_SORT_VALUES = ['event-date-earliest', 'event-date-latest'];

  function isWorkshopSortMode(value) {
    return WORKSHOP_SORT_VALUES.includes(value);
  }

  function isWorkshopCollectionGrid() {
    return document.getElementById('items-grid')?.dataset.workshopCollection === 'true';
  }

  function getWorkshopSortMode(searchParams) {
    const params =
      typeof searchParams === 'string'
        ? new URLSearchParams(searchParams)
        : new URLSearchParams(window.location.search);

    const workshopSort = params.get('workshop_sort');
    if (isWorkshopSortMode(workshopSort)) return workshopSort;

    const sortBy = params.get('sort_by');
    if (isWorkshopSortMode(sortBy)) return sortBy;

    if (isWorkshopCollectionGrid() && (!sortBy || sortBy === 'manual')) {
      return 'event-date-earliest';
    }
    return null;
  }

  function reactivateGridImages(grid) {
    const root = grid || document.getElementById('items-grid');
    if (!root) return;

    root.querySelectorAll('.animate_transition_card__image').forEach((el) => {
      el.classList.add('active', 'lazy_active');
      el.classList.remove('animate-Xpulse', 'skeleton-image');
    });
    root.querySelectorAll('.animate_transition_image').forEach((el) => {
      el.classList.add('active');
      el.classList.remove('animate-Xpulse', 'skeleton-image');
    });
    root.querySelectorAll('img.skeleton-image, img.animate_transition_image').forEach((el) => {
      el.classList.add('active');
      el.classList.remove('animate-Xpulse', 'skeleton-image');
    });
  }

  function reorderChildren(container, items, isMatch) {
    const children = Array.from(container.children);
    let sortedIndex = 0;
    children.forEach((child) => {
      if (isMatch(child)) {
        container.appendChild(items[sortedIndex++]);
      } else {
        container.appendChild(child);
      }
    });
  }

  function sortWorkshopItems(container, items, direction, isMatch) {
    if (!container || items.length < 2 || !window.WorkshopDateUtils) return;
    const now = new Date();
    const sortedItems = [...items].sort((a, b) =>
      window.WorkshopDateUtils.compareWorkshopItems(a, b, direction, now)
    );
    reorderChildren(container, sortedItems, isMatch);
  }

  function sortCollectionWorkshopGrid(mode) {
    const grid = document.getElementById('items-grid');
    if (!grid || grid.dataset.workshopCollection !== 'true') return;

    const direction = mode === 'event-date-latest' ? -1 : 1;
    const gridItems = Array.from(grid.children).filter((el) => el.classList.contains('grid-item'));
    sortWorkshopItems(grid, gridItems, direction, (el) => el.classList.contains('grid-item'));
  }

  function sortFeaturedWorkshopLists(root) {
    const scope = root || document;
    const lists = scope.querySelectorAll
      ? scope.querySelectorAll('[data-featured-workshop-sort]')
      : [];
    lists.forEach((list) => {
      const direction = list.dataset.workshopSortDirection === 'latest' ? -1 : 1;
      const items = Array.from(list.children).filter(
        (el) => el.classList.contains('card-product') || el.classList.contains('splide__slide')
      );
      sortWorkshopItems(
        list,
        items,
        direction,
        (el) => el.classList.contains('card-product') || el.classList.contains('splide__slide')
      );
    });
  }

  function applyWorkshopSort(searchParams) {
    const mode = getWorkshopSortMode(searchParams);
    if (mode) {
      sortCollectionWorkshopGrid(mode);
    }
    reactivateGridImages();
  }

  window.xCollectionWorkshopSort = {
    isWorkshopSortMode,
    applyWorkshopSort,
    sortCollectionWorkshopGrid,
    sortFeaturedWorkshopLists,
    getWorkshopSortMode,
    reactivateGridImages,
  };

  function init() {
    const run = () => {
      if (isWorkshopCollectionGrid()) {
        applyWorkshopSort();
      }
      sortFeaturedWorkshopLists();
      reactivateGridImages();
    };

    requestAnimationFrame(run);
    setTimeout(run, 300);
    setTimeout(run, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
